import { SET_ITEM_SELECTED, SET_SELECTED } from '../../../actions/chart';
import _ from 'lodash';

export default selectionType => (state = [], action) => {
  if (action.selectionType !== selectionType) {
    return state;
  }

  switch (action.type) {
    case SET_ITEM_SELECTED:
      return action.payload.selected ? _.union(state, [action.payload.id]) : _.without(state, action.payload.id);
    case SET_SELECTED:
      return action.payload.list;
    default:
      return state;
  }
};

export const getSelected = state => state;